import { Popover, Pressed, Stack } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const PopoverStyled = styled(Popover)(() => ({
  marginTop: 24,
  [Popover.classes.paper]: {
    minWidth: 292,
    maxWidth: 320,
  },
}));

export const PopoverContentStyled = styled(Stack)(() => ({
  '.headerUser-popoverContent-wrapper': {
    padding: '12px 16px',
  } as CSSObject,
  '.headerUser-popoverContent-line': {
    backgroundColor: Colors.gray200,
    height: 1,
  } as CSSObject,
  '.headerUser-popoverContent-action': {
    '&:hover': {
      backgroundColor: Colors.gray100,
    },
  } as CSSObject,
}));

export const UserStyled = styled(Pressed)(() => ({
  background: '#D6F4FF',
  width: 44,
  height: 44,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '.user-name': {
    color: '#0079A5',
  },
}));
